import React from "react";

const Wedding1st = () => {
  return (
    <div>
      <img
        className="wedding-landing"
        src="./Assets/weddinglanding.webp"
        alt="img"
      ></img>
    </div>
  );
};

export default Wedding1st;
